import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay, requireAuth } from '@/test/mocks/utils';

import { GetVideoSegmentationDataResponse } from '../types';

export const getVideoSegmentationData = (
  session_id: string
): Promise<GetVideoSegmentationDataResponse.Root> => {
  return axios.get(`/user/v1/get-video-segmentation-data/${session_id}`);
};

export const getVideoSegmentationDataMockHandler = http.get(
  `${env.API_URL}/user/v1/get-video-segmentation-data/:session_id`,
  async ({
    cookies,
  }): Promise<HttpResponse<GetVideoSegmentationDataResponse.Root>> => {
    await networkDelay();
    const { error } = requireAuth(cookies);
    if (error) {
      return HttpResponse.json(
        {
          message: error,
          status: 'Failure',
          session_id: '',
          data_source: '',
          from_cache: false,
        },
        { status: 401 }
      );
    }

    return HttpResponse.json({
      message: 'Segmentation details retrieved from S3 cache',
      session_id: 'session_123',
      status: 'completed',
      segmentation_data: {
        segments: [
          {
            start_time: 0,
            end_time: 150,
            title: 'Class Introduction',
            description:
              'Teacher welcomes students and introduces multiplication techniques',
          },
          {
            start_time: 150,
            end_time: 300,
            title: 'Mental Multiplication Basics',
            description:
              'Teacher explains the fundamentals of mental multiplication',
          },
        ],
      },
      transcript_data: [
        {
          text: "Welcome everyone to today's mental math class...",
          timestamp: '0-150',
          speaker: 'teacher',
        },
      ],
      data_source: 's3_cache',
      from_cache: true,
      request_timestamp: 1_642_687_200,
    });
  }
);
